import { createRef, useEffect, useRef, useState } from "react";
import { PhoneInput, type PhoneInputRefType } from "react-international-phone";
import { getCountry } from "../../helpers/countries";

interface IInputField {
  label: string;
  name: string;
  value: string;
  error: boolean | null;
  validate: { [key: string]: string | number | boolean };
  errorMessages: { [key: string]: string };
  valueCallback: (obj: { [key: string]: string }) => void;
  validationCallBack: (obj: { [key: string]: boolean | null }) => void;
}

function PhoneField(props: IInputField) {
  const {
    label,
    name,
    value,
    error,
    validate,
    errorMessages,
    valueCallback,
    validationCallBack,
  } = props;

  const [isInValid, setIsInValid] = useState<string | null>(null);
  const inputRef = createRef<PhoneInputRefType>();
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;

      if (value !== "" && value.length > 5) {
        handleBlur();
      }
    } else {
      handleBlur();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, error]);

  const handleBlur = () => {
    setIsInValid(null);
    let valid = null;
    Object.keys(validate).forEach((err) => {
      // Validate min
      if (err === "min" && value?.length < Number(validate[err])) {
        valid = "min";
      }
      // Validate numeric
      else if (err === "phonenumber") {
        // Check if only numbers
        if (value && value.length > 1 && value.match(/^[0-9]+$/) !== null) {
          //
        } else {
          valid = "phonenumber";
        }
      }
    });

    let obj: { [key: string]: boolean | null } = {};
    if (valid === null) {
      obj[name as keyof typeof obj] = true;
      validationCallBack(obj);
    } else {
      obj[name as keyof typeof obj] = false;
      validationCallBack(obj);
      setIsInValid(valid);
    }
  };

  const handleFocus = () => {
    inputRef.current?.focus();
  };

  const handleInputFromPhone = (phone: string | undefined) => {
    if (!isInitialMount.current) {
      const numeric = phone ? phone.replace(/\D/g, "") : "";
      let obj: { [key: string]: string } = {};
      obj[name] = numeric;
      valueCallback(obj);
      handleBlur();
    }
  };

  return (
    <div onClick={() => handleFocus()}>
      <span>{label}</span>
      <div
        className={`flex items-center gap-2 bg-white rounded-md border mt-1 text-fluid-base ${
          error === false ? "border-red-600" : "border-custom-400"
        }`}
      >
        <PhoneInput
          ref={inputRef}
          defaultCountry={getCountry()?.toLowerCase() || "nl"}
          value={value ? `+${value}` : undefined}
          onChange={(phone: any) => handleInputFromPhone(phone)}
          onBlur={handleBlur}
          onFocus={handleFocus}
        />
      </div>

      {error === false && errorMessages && (
        <div className="text-fluid-xs text-red-600 text-right mt-1">
          {Object.keys(errorMessages).map((err, i) => {
            if (err === isInValid) {
              return <div key={i}>{errorMessages[err]}</div>;
            } else {
              return "";
            }
          })}
        </div>
      )}
    </div>
  );
}

export default PhoneField;
